import { useEventListener } from '@vueuse/core';
import { toValue } from 'vue';

/**
 * @typedef {(evt:FocusEvent) => void} OnFocusOutsideHandler
 *
 * @param {import('vue').MaybeRefOrGetter<Node | null | undefined>} target
 * @param {OnFocusOutsideHandler} handler
 */
export default function onFocusOutside(target, handler) {
    return useEventListener(document, 'focusin', /** @param {FocusEvent} event */(event) => {
        const el = toValue(target)
        if (event.target && !el?.contains(/** @type {Node} */(event.target))) {
            return handler(event)
        }
    })
}